import React from 'react';
import { Metadata, MediaEventHandlers, PhotoControls } from './media-displayer';
import PhotoView from './photo-view';

const configuredPhotoView = (
  metadata: Metadata,
  handlers?: MediaEventHandlers & PhotoControls,
): React.ReactElement => {
  const noop = () => {};
  const imageSrc = document.body.offsetWidth > 1450 ? metadata.original : metadata.large;
  const imageHeight = Number(metadata.exif?.pixel_y_dimension);
  const imageWidth = Number(metadata.exif?.pixel_x_dimension);

  return (
    <PhotoView
      imageSrc={imageSrc || ''}
      originalSrc={metadata.original}
      onResize={handlers?.onResize || noop}
      isZoomable={metadata.isZoomable || false}
      photoRef={metadata.ref || null}
      panoramaEnabled={metadata.panoramaEnabled || false}
      switchPhotoViewer={handlers?.switchPhotoViewer || noop}
      dimensions={{
        width: imageWidth,
        height: imageHeight,
      }}
      accessId={metadata.accessID || ''}
      disableRecognition={handlers?.disableRecognition || noop}
      enableRecognition={handlers?.enableRecognition || noop}
    />
  );
};
export default configuredPhotoView;
